import Icon from 'veui/components/Icon'

Icon.register({
  'sign-x': {
    paths: [
      {
        d: 'M519.63 293.63L429.26 384l90.37 90.37a32 32 0 01-45.26 45.26L384 429.26l-90.37 90.37a32 32 0 01-45.26-45.26L338.74 384l-90.37-90.37a32 32 0 0145.26-45.26L384 338.74l90.37-90.37a32 32 0 0145.26 45.26zM736 384A352.09 352.09 0 0159.67 521a352.09 352.09 0 01648.66-274A349.83 349.83 0 01736 384zm-64 0a288 288 0 10-84.35 203.65A286.15 286.15 0 00672 384z'
      }
    ],
    width: '768',
    height: '768'
  }
})
